// src/components/ui/PageSizeSelector.tsx
import React from 'react';
import { Select, Group, Text } from '@mantine/core';

interface PageSizeSelectorProps {
  value: number;
  onChange: (value: number) => void;
  options?: number[];
  label?: string;
}

const DEFAULT_OPTIONS = [10, 25, 50, 100];

export function PageSizeSelector({
  value,
  onChange,
  options = DEFAULT_OPTIONS,
  label = 'Elementi per pagina:',
}: PageSizeSelectorProps) {
  return (
    <Group gap="xs">
      <Text size="sm" c="dimmed">{label}</Text>
      <Select
        size="xs"
        w={80}
        value={String(value)}
        onChange={(val) => val && onChange(Number(val))}
        data={options.map((opt) => ({
          value: String(opt),
          label: String(opt),
        }))}
        allowDeselect={false}
      />
    </Group>
  );
}
